import { render, staticRenderFns } from "./AfterSalesTab.vue?vue&type=template&id=204d63ad"
import script from "./AfterSalesTab.vue?vue&type=script&lang=js"
export * from "./AfterSalesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "756b16f6"
  
)

export default component.exports